export const closeModal = function (buttonClicked) {

    buttonClicked.closest(".modal").style.display = "none";
    document.body.classList.remove("stop-scrolling");
    if (buttonClicked.getAttribute("data-video-number") === "first-video") {
        playerOne.pause();
    }

    if (buttonClicked.getAttribute("data-video-number") === "second-video") {
        playerTwo.pause();
    }
}

export const openModal = function (videoClicked) {

    window.scrollTo(0,0);
    document.body.classList.add("stop-scrolling");

    if (videoClicked.getAttribute("data-video-clicked") === "first") {
        document.getElementById("firstModal").style.display = "block";
    }

    if (videoClicked.getAttribute("data-video-clicked") === "second") {
        document.getElementById("secondModal").style.display = "block";
    }
}
